import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./store";

// En lugar de usar useDispatch generico, usa este que ya se sabe que tipos esperar
export const useAppDispatch = () => useDispatch<AppDispatch>()

// En lugar de usar useSelector generico de Redux, usa este (useAppSelector) que ya sabe la estructura del state
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector